import { FC } from "react";
import { Box } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import { EMPTY_VALUE_PLACEHOLDER } from "constants/index";
import {
  formatCurrencyAmount,
  formatMarketplaceMedianAmountSource,
  formatNumber,
} from "lib/format";
import { BaseAmountSource } from "services/listings/types";
import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    amountWithMultiple: {
      fontSize: "85%",
      display: "block",
      color: theme.custom.palette.softGray.main,
    },
  }),
);

interface AmountWithMultipleProps {
  amount: number | string;
  multiple: number;
  multipleSource: BaseAmountSource;
  currency: string;
  isClosedListing?: boolean;
}

const AmountWithMultiple: FC<AmountWithMultipleProps> = ({
  amount,
  multiple,
  multipleSource,
  currency,
  isClosedListing,
}) => {
  const classes = useStyles();
  return (
    <Box>
      {amount ? (
        <span
          style={{
            color: isClosedListing
              ? theme.custom.palette.softRed.main
              : theme.custom.palette.black.main,
            fontWeight: isClosedListing ? "bold" : "normal",
          }}
        >
          {formatCurrencyAmount(currency, amount)}
        </span>
      ) : (
        EMPTY_VALUE_PLACEHOLDER
      )}
      <span className={classes.amountWithMultiple}>
        {multiple && isFinite(multiple) && multipleSource
          ? `${formatNumber(multiple)} x ${formatMarketplaceMedianAmountSource(
              multipleSource,
            )}`
          : EMPTY_VALUE_PLACEHOLDER}
      </span>
    </Box>
  );
};

export default AmountWithMultiple;
